import React, { Component, PureComponent, Fragment } from 'react'
import { Map, List, fromJS } from 'immutable'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Message, Button, Table } from 'semantic-ui-react'
import { SubeditorArea } from '~/common/subeditor'
import PeopleAdd from '~/people/views/add'
import PeopleEdit from '~/people/views/edit'
import ConnectPerson from './connectPerson'
import { batchCreatePeople } from '~/people/actions'
import { replace, push } from 'react-router-redux'
import QueryString from 'query-string'

function PeopleTableArea({ title = false, people, faded = false, status: statusColor, updateLocation }) {
  if (!people.size) return null

  return (
    <Fragment>
      {title ? (
        <Table.Row>
          <Table.Cell colSpan="6" className="table-sub-title">
            {title}
          </Table.Cell>
        </Table.Row>
      ) : null}
      {people
        .map(p => {
          let id = p.get('id')
          let email = p.get('email', '')
          let lang = p.get('lang', 'FI')
          let status = p.get('status', 'pending')
          let interview_id = p.get('interview_id', false)
          let data = p.get('data', Map())

          return (
            <Table.Row key={id} className={faded ? 'faded' : ''}>
              <Table.Cell>
                <span className={`status status--${statusColor}`} />
                <button className="button-plain" onClick={e => e.preventDefault() & updateLocation({ editing: id })}>
                  {data.get('name')}
                </button>
              </Table.Cell>
              <Table.Cell>{email}</Table.Cell>
              <Table.Cell>{data.get('phone')}</Table.Cell>
              <Table.Cell>{data.get('address')}</Table.Cell>
              <Table.Cell>{lang}</Table.Cell>
              <Table.Cell>
                <div className="table-ellipsis">
                  <span className="ellipsis">{data.get('notes')}</span>
                </div>
              </Table.Cell>
              <Table.Cell>{interview_id}</Table.Cell>
            </Table.Row>
          )
        })
        .toArray()}
    </Fragment>
  )
}

class ProjectPeopleEditor extends Component {
  createPeople = people => {
    let { createPeople, project } = this.props
    createPeople(people, project.get('id'))
    this.setState({ adding: false })
  }

  updateLocation = state => {
    let { location, pushLocation } = this.props
    location.search = QueryString.stringify(state)
    pushLocation(location)
  }

  render() {
    let { project, people, interviews, createLoading, createError, location } = this.props

    let { adding = 'false', editing = false } = QueryString.parse(location.search || '')

    adding = adding === 'true'

    let addButton = (
      <Button
        content="Lisää henkilöitä"
        color="green"
        size="tiny"
        onClick={e => e.preventDefault() & this.updateLocation({ adding: true })}
      />
    )

    let editingPerson = editing ? people.find(p => p.get('id') === editing) : false

    return (
      <div className="subeditor-container">
        <SubeditorArea title="Haastateltavat" buttons={addButton}>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Nimi" />
                <Table.HeaderCell content="Sähköposti" />
                <Table.HeaderCell content="Puhelin" />
                <Table.HeaderCell content="Osoite" />
                <Table.HeaderCell content="Kieli" />
                <Table.HeaderCell content="Muistiinpanot" />
                <Table.HeaderCell content="Haastattelu" />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              <PeopleTableArea
                people={people.filter(p => p.get('status') === 'pending')}
                updateLocation={this.updateLocation}
                status="yellow"
              />
              <PeopleTableArea
                title="Soita myöhemmin uudestaan"
                status="info"
                people={people.filter(p => p.get('status') === 'callback')}
                updateLocation={this.updateLocation}
              />
              <PeopleTableArea
                title="Odottaa haastatteluun yhdistämistä"
                status="success"
                people={people.filter(p => p.get('status') === 'accepted' && !p.get('interview_id', false))}
                updateLocation={this.updateLocation}
              />
              <PeopleTableArea
                title="Haastattelu sovittu"
                status="success"
                people={people.filter(p => p.get('interview_id', false))}
                updateLocation={this.updateLocation}
              />
              <PeopleTableArea
                title="Kieltäytyneet"
                status="error"
                people={people.filter(p => p.get('status') === 'declined')}
                faded
                updateLocation={this.updateLocation}
              />
            </Table.Body>
          </Table>
        </SubeditorArea>
        <PeopleAdd
          open={adding}
          loading={createLoading}
          onCreate={this.createPeople}
          onClose={() => this.updateLocation({})}
        />
        {editingPerson ? (
          <ConnectPerson
            person={editingPerson}
            project={project}
            interviews={interviews}
            onClose={() => this.updateLocation({})}
          />
        ) : null}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    createLoading: state.batchCreatePeopleLoading,
    createError: state.batchCreatePeopleErrorMessage,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPeople: (people, project_id) => dispatch(batchCreatePeople(people, project_id)),
    replaceLocation: location => dispatch(replace(location)),
    pushLocation: location => dispatch(push(location)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectPeopleEditor))
